import React, { useState, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AxiosError } from "axios";
import { Form, Formik, FormikHelpers, FormikValues } from "formik";
import {
  AuthCard,
  ResetPasswordInitialValues as initValues,
  resetPasswordSchema,
} from "./components/constants";
import { IconCloseEye, IconEye } from "../../utils/icons";
import { BasicPage, FieldText, FormButton } from "./components";
import axiosInstant from "../../api";
import { postUseAutoLoginRedirect } from "../../api/endpoints";
import { useBoundStore } from "../../store";

export function AutoLoginRedirectPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("token");
  const [status, setStatus] = useState("Authenticating...");
  const autoLogin = useBoundStore((state) => state.autoLogin);
  
  // use effect
  useEffect(() => {
    useAutoLoginRedirect();
  }, []);

  const useAutoLoginRedirect = async () => {
    try {

      let response:any = await axiosInstant.post(postUseAutoLoginRedirect(), {
        hash,
      });

      setStatus("Authenticated. Logging In...");

      console.log('response', response);
      
      let login = await autoLogin(response.data.resultB);
    
      console.log('login', login);

      setStatus("Login Successful.");
      
      navigate("/");

    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        const { data } = axiosError.response;
      }
      setStatus("Authentication Failed.");
    }
  };

  return (
    <BasicPage>
      <AuthCard elevation={0} variant="outlined">
        <Box textAlign="center" display="flex" flexDirection="column" gap={5}>
          <p>{status}</p>
          {/* <Typography variant="h5">
            Reset Password
          </Typography>
          <Formik
            initialValues={initValues}
            validationSchema={resetPasswordSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Stack spacing={5} width={1}>
                  <Stack spacing={2} marginBottom={5}>
                    <Box position="relative">
                      <FieldText
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        fullWidth
                        inputProps={{ paddingRight: 5 }}
                      />
                      <Box
                        position="absolute"
                        sx={{ right: 10, top: 12, cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <IconCloseEye />
                        ) : (
                          <IconEye stroke="#868686" />
                        )}
                      </Box>
                    </Box>
                    <Box position="relative">
                      <FieldText
                        name="passwordConfirmation"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Password Confirmation"
                        fullWidth
                        inputProps={{ paddingRight: 5 }}
                      />
                      <Box
                        position="absolute"
                        sx={{ right: 10, top: 12, cursor: "pointer" }}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <IconCloseEye />
                        ) : (
                          <IconEye stroke="#868686" />
                        )}
                      </Box>
                    </Box>
                  </Stack>
                  <FormButton
                    text="Submit"
                    isLoadingBtn
                    loading={isSubmitting}
                  />
                </Stack>
              </Form>
            )}
          </Formik> */}
        </Box>
      </AuthCard>
    </BasicPage>
  );
}
